import { hasShadowDom as e } from "./hasShadowDom.js";
const m = () => {
  var o;
  const t = document.activeElement;
  return e(t) ? ((o = t == null ? void 0 : t.shadowRoot) == null ? void 0 : o.activeElement) || void 0 : t || void 0;
};
export {
  m as getActiveElement
};
